export const CLEARED_FILTERS_COOKIE_NAME = 'blcf';
